var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{},[_c('b-row',[_c('b-col',{class:{ 'form-disabled': _vm.isBusy },attrs:{"cols":"12"}},[_c('FullCalendar',{ref:"fullCalendar",attrs:{"options":_vm.calendarOptions}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }